import calculateGraph from './calculateGraph';

export default function processSubOrders(subOrders) {

	let lookup = subOrders.reduce((acc,c) => ({ ...acc, [c.id]: c }), {});

	ensureNoCycles(subOrders, lookup);
	subOrders = calculateDepth(subOrders, lookup);
	subOrders = calculateWidth(subOrders);

	return calculateGraph(subOrders);
}

function ensureNoCycles(subOrders, lookup) {
	let visitCounts = {};
	let toCheck = subOrders.filter(x => x.prev.length === 0); // Get all starting point
	while (toCheck.length > 0) {
		let subOrder = toCheck.shift();
		let existingVisits = visitCounts[subOrder.id] || 0;
		if (existingVisits > subOrder.prev.length)
			throw new Error(`Cycle detected on node with id ${  subOrder.id}`);
		visitCounts[subOrder.id] = existingVisits + 1;
		let nextOrders = subOrder.next.map(x => {
			if (lookup[x])
				return lookup[x];
			throw new Error(`SubOrder`);
		});
		toCheck.unshift(...nextOrders);
	}
}

function calculateDepth(subOrders, lookup) {
	let result = {};
	let toCheck = subOrders.filter(x => x.prev.length === 0).map(x => ({ depth: 0, subOrder: x })); // Get all starting point
	while (toCheck.length > 0) {
		let { depth, subOrder } = toCheck.shift();
		let existing = result[subOrder.id] || { depth: -1 };
		depth = Math.max(depth, existing.depth);
		result[subOrder.id] = { depth, subOrder };
		let nextOrders = subOrder.next.map(x => ({ depth: depth+1, subOrder: lookup[x] }));
		toCheck.unshift(...nextOrders);
	}

	return Object.values(result);
}

function calculateWidth(subOrdersAndDepth) {
	let lookup = subOrdersAndDepth.reduce((acc,c) => ({ ...acc, [c.subOrder.id]: c }), {});
	let currentMaxWidth = 0;
	let starts = subOrdersAndDepth.filter(x => x.subOrder.prev.length === 0);

	for (let start of starts) {
		calculateWidthCore(start, currentMaxWidth);
		currentMaxWidth += 1;
	}
	return subOrdersAndDepth;

	function calculateWidthCore(subOrderAndDepth, width) {
		subOrderAndDepth.width = width;
		currentMaxWidth = Math.max(width, currentMaxWidth);
		let nexts = subOrderAndDepth.subOrder.next.map(x => lookup[x]);
		nexts.forEach((x,i) => {
			if (x.width <= width+i) return;

			calculateWidthCore(x, width+i);
		});
	}
}

